import type { PortfolioGroup } from "./types";
import type { FlattenedPortfolioItem } from "@/types";
import { groupBy, maxBy, sumBy } from "lodash-es";

const EXCLUDED_PORTFOLIO_TYPES = new Set(["UNALLOCATED"]);

const INACTIVE_STATUSES = new Set([
  "CANCELLED",
  "TRANSFERRED",
  "SOLD",
  "ONGOING_SALE",
]);

export function groupItemsIntoPortfolios(
  items: FlattenedPortfolioItem[]
): PortfolioGroup[] {
  const filtered = items.filter(
    (item) => !EXCLUDED_PORTFOLIO_TYPES.has(item.portfolio_type)
  );

  const grouped = groupBy(filtered, "portfolio_id");

  return Object.entries(grouped).map(([portfolioId, portfolioItems]) => {
    const firstItem = portfolioItems[0];
    const latestItem = maxBy(portfolioItems, (item) => item.updated_at);
    const activeItems = portfolioItems.filter(
      (item) => !INACTIVE_STATUSES.has(item.status)
    );

    return {
      id: Number(portfolioId),
      name: firstItem.portfolio_name,
      portfolio_type:
        firstItem.portfolio_type as PortfolioGroup["portfolio_type"],
      is_default: firstItem.is_default,
      total_volume: sumBy(activeItems, "count"),
      updated_at: latestItem?.updated_at ?? firstItem.updated_at,
      items: portfolioItems,
      limit_price: firstItem.limit_price ?? null,
    };
  });
}
